import i18next from "i18next";
import { showErrorToast } from "../components/general/ToastHelper";
import history from "./history";
import InvalidSessionError from "./InvalidSessionError";

export function handleError(e) {
  if (e instanceof InvalidSessionError) {
    history.push("/logout");
    showErrorToast(i18next.t(e.message));
  } else {
    showErrorToast(i18next.t(e.message));
  }
}
